export const baseUrl = process.env.REACT_APP_API_URL;

export type ErrorDetails<T = any> = {
  status: string;
  error: Partial<T>;
};
